import { render, staticRenderFns } from "./posts.vue?vue&type=template&id=23f3c93b"
var script = {}


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {LayoutBanner: require('/opt/build/repo/components/layout/Banner.vue').default})
